var _g, _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseDescriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4950:6077)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.0444,
    cy: 13.0444,
    r: 8.5167,
    transform: "rotate(-45 13.0444 13.0444)",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.99023,
    y: 13.0346,
    width: 8.55326,
    height: 8.72097,
    transform: "rotate(-45 6.99023 13.0346)",
    stroke: "#979797",
    strokeOpacity: 0.01,
    strokeWidth: 0.408839
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5074 13.098L15.6592 10.9461C15.7712 10.8343 15.7694 10.6506 15.6552 10.5366C15.5409 10.4223 15.3577 10.4205 15.2456 10.5326L13.0938 12.6844L10.8998 10.4904C10.7856 10.3761 10.6023 10.3743 10.4902 10.4864C10.3782 10.5983 10.38 10.7819 10.4942 10.896L12.6882 13.09L10.5364 15.2419C10.4243 15.3537 10.4261 15.5374 10.5404 15.6514C10.5975 15.7086 10.6719 15.7375 10.7461 15.7382C10.8203 15.7389 10.8939 15.7115 10.95 15.6554L13.1018 13.5036L15.2957 15.6976C15.3529 15.7547 15.4273 15.7837 15.5015 15.7844C15.5756 15.7851 15.6493 15.7576 15.7053 15.7016C15.8174 15.5897 15.8156 15.4061 15.7013 15.292L13.5074 13.098Z",
    fill: "#8481C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5074 13.098L15.6592 10.9461C15.7712 10.8343 15.7694 10.6506 15.6552 10.5366C15.5409 10.4223 15.3577 10.4205 15.2456 10.5326L13.0938 12.6844L10.8998 10.4904C10.7856 10.3761 10.6023 10.3743 10.4902 10.4864C10.3782 10.5983 10.38 10.7819 10.4942 10.896L12.6882 13.09L10.5364 15.2419C10.4243 15.3537 10.4261 15.5374 10.5404 15.6514C10.5975 15.7086 10.6719 15.7375 10.7461 15.7382C10.8203 15.7389 10.8939 15.7115 10.95 15.6554L13.1018 13.5036L15.2957 15.6976C15.3529 15.7547 15.4273 15.7837 15.5015 15.7844C15.5756 15.7851 15.6493 15.7576 15.7053 15.7016C15.8174 15.5897 15.8156 15.4061 15.7013 15.292L13.5074 13.098",
    stroke: "#8481C0",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4950:6077",
    x: 0.527832,
    y: 0.52774,
    width: 25.0332,
    height: 25.0334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.23 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4950:6077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4950:6077",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseDescriptionIcon);
export default __webpack_public_path__ + "static/media/closeDescriptionIcon.05d7cdfcd5a861af068fab2b0174af31.svg";
export { ForwardRef as ReactComponent };